import React, { Component } from "react";
import Tooltip from "../../components/UI/TooltipIcon/TooptipIcon";
import orderBy from "lodash/orderBy";
import { withRouter } from "react-router-dom";
import moment from "moment";
import { BiDotsHorizontalRounded, BiInfoCircle } from "react-icons/bi";
import DaniIcon from "./../../assets/dani_icon.svg";

import { IoChatboxOutline } from "react-icons/io5";
import {
  Modal,
  ModalBody,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Popover,
  PopoverHeader,
  PopoverBody,
  Row,
  Col,
  ModalHeader,
} from "reactstrap";
import { connect } from "react-redux";
import reply from "../../assets/stories/reply.svg";
import {
  NO_CONTENT_MESSAGE,
  profilePicValidityCheck,
  renderGenderPronoun,
  Spinner,
} from "../../utils/constants";
import Select from "react-select";
import "rc-checkbox/assets/index.css";
import { marked } from "marked";
import parse from "html-react-parser";

import {
  storyReactions,
  storyTemplates,
  staticTitles,
  createUrlLink,
  dynamic_urls,
  createMentionUrl,
  matchUrl,
  checkUploadType,
  uploadPreview,
  wordFilter,
} from "../../utils/constants";
import { MentionsInput, Mention } from "react-mentions";
import "./Stories.css";
import Loading from "../../hoc/Loading/Loading";
import Reactions from "./Reactions.jsx";
import StoryCommentList from "./StoryCommentList.jsx";
import defaultStyle from "./defaultStyle";
import defaultMobileStyle from "./defaultMobileStyle";
import defaultMentionStyle from "./defaultMentionStyle";
import classNames from "./Stories.css";
import Toggle from "react-toggle";
import axios from "../../axios";
import * as url from "../../utils/url";
import * as actionCreators from "../../modules/actions/index";
import { ListGroup, ListGroupItem } from "reactstrap";
import avatarIcon from "../../assets/default-avatar.png";
import ShowMore from "react-show-more";
import PlaceholderStories from "./PlaceholderStories";
import If from "../../components/Shared/If";
import classnames from "classnames";
import get from "lodash/get";
import filter from "lodash/filter";
import { isMobile } from "../../utils/deviceInfo";
import arrowImg from "../../assets/arrow-down.svg";
import FooterBar from "../../components/FooterBar/FooterBar";
import UserIcon4 from "../../assets/user-image-plc/User_Icon_4.svg";
import ReactPlayer from "react-player/lazy";
import StoriesPhotoGrid from "./StoriesPhotoGrid";
import StoriesPhotoCarousel from "./StoriesPhotoCarousel";
import StoryItems from "./StoryItems.jsx";
import StoryMentionsText from "../../components/CreateStory/StoryMentionsText";
import groupIcon from "../../assets/placeholders/group.svg";
import EditStory from "../../components/CreateStory/EditStory";
import SharedUsersModal from "../../components/SharedUsersModal/SharedUsersModal";
import ShareStory from "../../components/ShareEntity/ShareEntity";
import ReportStoryModal from "./ReportStoryModal";
import { toastContainer } from "../../utils/toast";

class SingleStory extends Component {
  constructor(props) {
    super(props);
    const hideAnonymous =
      props.user.profile && props.user.profile.organizationId.disableAnonymity
        ? props.user.profile.organizationId.disableAnonymity.cultureApp
        : false;

    this.state = {
      flaggedHistory: [],
      flaggedHistoryOpen: false,
      stories: [],
      archievedStories: [],
      privacy: "PUBLIC",
      isAnonymous: false,
      isAnonymousVisible: !hideAnonymous,
      storyType: "Story",
      disableSubmit: true,
      isVideo: null,
      showReplies: false,
      mentionsSelected: [],
      isBadWords: "",
      setImagesPreview: [],
      isDescription: null,
      isSubmit: false,
      rejectedFiles: [],
      mentionsFound: [],
      showResponses: [],
      isCommentsOpen: false,
      ogp: {
        urlScrape: false,
        requestUrl: "",
        // urlScrape:false,
        // ogImage:"",
        // ogDesc:"",
        // ogTitle:"",
        // ogType:"",
        // ogUrl:"",
        // ogSiteName:"",
        // extra:{}
      },
      responseCounter: 0,
      showUserReactions: false,
      showReactions: null,
      reactionCounter: 0,
      showCarousel: false,
      reactionList: [],
      userReacted: "null",
      mentionWord: "",
      carouselData: [],
      item: null,
      userReactions: [],
      description: {
        value: "",
        error: false,
      },
      response: "",
      topics: [],
      mentionBool: false,
      mentionsIndex: 0,
      dropdownOpen: false,
      title: "",
      showCreateStoryModal: false,
      modalActionType: "Create",
      categoryDefinitionPopoverOpen: false,
      collapseCompleted: true,
      showRemoveFeedConfirmationModal: false,
      storyIdRemove: "",
      sharedUsersOpen: false,
      sharedUsers: [],
      isFlagged: {},
      reportedModalId: null,
    };
  }

  componentWillUnmount = () => {
    console.log("single 162------");
    this.props.updateNavBar({
      backButtonData: {
        show: false,
        currentPageType: "",
        editPopupOpen: false,
      },
    });
  };

  toggleEditPopup = () => {
    this.setState({ editPopupOpen: !this.state.editPopupOpen });
  };

  componentDidMount() {
    console.log("single story------");
    // console.log(this.props)
    // console.log('single story props!')
    this.props.updateNavBar({
      backButtonData: {
        show: true,
        currentPageType: "STORY_DETAILS",
      },
    });
    let orgId = this.props.user.profile.organizationId._id;
    let id;
    if (this.props.storyGroupId) {
      id = this.props.storyGroupId;
    } else {
      id = this.props.match.params.id;
    }

    let userId = this.props.user.profile._id;
    var that = this;
    console.log(id);
    this.grabStoryContent(orgId, id, userId);
    // axios.all([
    //   axios.get(url.getTopics(orgId)),
    //   axios.get(url.getSingleStory(id)),
    //   axios.get(url.getStoryComments(id))
    //   ])
    // .then(axios.spread(function (topics, storyRes, replyData) {
    //   let foundtopic = topics.data.data
    //   let item = storyRes.data.data[0]
    //   let arr = replyData.data.data.storyList
    //   console.log(item,arr,foundtopic)

    //   that.setState({
    //     topics: [...foundtopic],
    //     responseCounter:item.storyCounter,
    //         disableSubmit: true,
    //         showUserReactions:false,
    //         showReactions:null,
    //         item,
    //         reactionCounter: item.reactionArr && item.reactionArr.reactions &&item.reactionArr.reactions.length>0?item.reactionArr.reactions.length:0,
    //         reactionList: item.reactionArr && item.reactionArr.reactions &&item.reactionArr.reactions.length>0?item.reactionArr.reactions.slice(0,3):[],
    //         userReacted: item.reactionArr && item.reactionArr.reactions &&item.reactionArr.reactions.length>0?item.reactionArr.reactions.filter(e=>{
    //           return e.userId === userId
    //         }) : "null",
    //         showResponses: arr,
    //         isCommentsOpen: false,
    //         responseCounter: arr.length
    //   });
    // }))
  }

  componentDidUpdate() {
    console.log("229 story------");
    const { item } = this.state;
    if (!isMobile || !item) return;
    const { search } = this.props.location;

    let backTxt = "",
      backTo = null;
    if (search.includes("?notifications")) {
      backTxt = "Notifications";
      backTo = "/home/notifications";
    } else if (search.includes("?me")) {
      backTxt = "My Posts";
      backTo = "/home/stories/me";
    } else {
      backTxt = "Culture App";
      backTo = "/home/stories";
    }

    this.props.updateNavBar({
      title: `<span className="singleStoryName"> ${
        item.isAnonymous
          ? "Anonymous user"
          : this.props.user.profile._id === item.userId
          ? "me"
          : item.fullname
      } </span>`,
      hasBack: true,
      backButton: `<b>${backTxt}</b>`,
      showNotification: true,
      className: null,
      backTo,
      isBreadCrumbs: true,
    });
  }

  componentWillReceiveProps(nextProps) {
    console.log("265 story------");
    if (!this.props.storyGroupId) {
      if (this.props.match.params.id !== nextProps.match.params.id) {
        // this.getStory(nextProps.match.params.id)
        // console.log(nextProps)
        // userid, orgid, id
        let story = nextProps.match.params.id;
        let orgId = nextProps.user.profile.organizationId._id;
        let userId = nextProps.user.profile._id;
        this.grabStoryContent(orgId, story, userId);
      }
    }
  }

  grabStoryContent = (orgId, id, userId) => {
    if (id == "undefined") {
      this.props.history.push("/home/stories");
      toastContainer(NO_CONTENT_MESSAGE, "error");
      return;
    }
    var that = this;
    axios
      .all([
        axios.get(url.getTopics(orgId)),
        axios.get(url.getSingleStory(id)),
        axios.get(url.getStoryComments(id)),
        axios.post(url.getFlaggedContentHistory, {
          storyId: id.replace("?me", "").replace("?false", ""),
        }),
      ])
      .then(
        axios.spread(function(topics, storyRes, replyData, flaggedData) {
          let foundtopic = topics.data.data;
          let item = storyRes.data.data[0];
          let arr = replyData.data.data.storyList;
          let flaggedHistory = flaggedData.data.data;
          // console.log(item,arr,foundtopic)

          if (!item) {
            that.props.history.push("/home/stories");
            toastContainer("You are not authorized to view this post", "error");
          } else {
            let showUI = true;
            if (item.privacy === "SHARED") {
              const { _id, orgAdmin } = that.props.user.profile;
              const isSharedWithMe = item.sharedWith.find(
                (x) => x.userId === _id
              );

              const isOwner = item.userId ? item.userId == _id : true;
              console.log({ isSharedWithMe, isOwner, orgAdmin });
              if (isSharedWithMe || orgAdmin || isOwner) {
                showUI = true;
              } else {
                showUI = false;
              }
            }

            if (showUI) {
              that.setState({
                flaggedHistory,
                topics: [...foundtopic],
                responseCounter: item.storyCounter,
                disableSubmit: true,
                showUserReactions: false,
                showReactions: null,
                item,
                isVideo:
                  item.ogp &&
                  item.ogp.ogType &&
                  item.ogp.ogType.indexOf("video") > -1
                    ? true
                    : false,
                reactionCounter:
                  item.reactionArr &&
                  item.reactionArr.reactions &&
                  item.reactionArr.reactions.length > 0
                    ? item.reactionArr.reactions.length
                    : 0,
                reactionList:
                  item.reactionArr &&
                  item.reactionArr.reactions &&
                  item.reactionArr.reactions.length > 0
                    ? item.reactionArr.reactions.slice(0, 3)
                    : [],
                userReacted:
                  item.reactionArr &&
                  item.reactionArr.reactions &&
                  item.reactionArr.reactions.length > 0
                    ? item.reactionArr.reactions.filter((e) => {
                        return e.userId === userId;
                      })
                    : "null",
                showResponses: arr,
                isCommentsOpen: false,
                responseCounter: arr.length,
                isFlagged: item.isFlagged,
              });
            } else {
              that.props.history.push("/home/stories");
              toastContainer(
                "You are not authorized to view this post",
                "error"
              );
            }
          }
        })
      );
  };

  getTopics = () => {
    let orgId = this.props.user.profile.organizationId._id;
    let { topics } = this.state;
    axios.get(url.getTopics(orgId)).then(({ data }) => {
      let foundtopic = data.data;
      this.setState({
        topics: [...foundtopic],
      });
      let id;
      if (this.props.storyGroupId) {
        id = this.props.storyGroupId;
      } else {
        id = this.props.match.params.id;
      }
      // console.log(this.props)
      this.getStory(id);
    });
  };

  getStory = (id) => {
    // console.log("story---", id)
    axios.get(url.getSingleStory(id)).then(({ data }) => {
      // console.log('data---', data.data)
      let item = data.data[0];
      // console.log(item)
      this.setState({
        responseCounter: item.storyCounter,
        disableSubmit: true,
        showUserReactions: false,
        showReactions: null,
        item,
        reactionCounter:
          item.reactionArr &&
          item.reactionArr.reactions &&
          item.reactionArr.reactions.length > 0
            ? item.reactionArr.reactions.length
            : 0,
        reactionList:
          item.reactionArr &&
          item.reactionArr.reactions &&
          item.reactionArr.reactions.length > 0
            ? item.reactionArr.reactions.slice(0, 3)
            : [],
        userReacted:
          item.reactionArr &&
          item.reactionArr.reactions &&
          item.reactionArr.reactions.length > 0
            ? item.reactionArr.reactions.filter((e) => {
                return e.userId === this.props.user.profile._id;
              })
            : "null",
      });
    });
  };

  toggleDropdown = (id) => {
    let { dropdownOpen } = this.state;
    if (dropdownOpen === id) {
      this.setState({ dropdownOpen: "" });
    } else {
      this.setState({ dropdownOpen: id });
    }
  };

  handleCreateStoryResponse = () => {
    let {
      description,
      isAnonymous,
      mentionData,
      sanitizedDescription,
      item,
      isListChecked,
      privacy,
      title,
      mentionsSelected,
      topicsSelected,
      ogp,
      setImagesPreview,
    } = this.state;

    this.setState({ isSubmit: true, isDescription: null });

    const formData = new FormData();
    let isUrl,
      isMention,
      mentions,
      that = this,
      newText;

    let cleanDesc = description.value ? wordFilter(description.value) : false;

    let user =
      this.props.user && this.props.user.profile
        ? this.props.user.profile
        : this.props.user;

    if (cleanDesc.length == 0) {
      newText = createUrlLink(description.value);
      newText = createMentionUrl(newText, user);
      // description.value = createUrlLink(description.value)
      // description.value = createMentionUrl(description.value, this.props.user)
      let desc = `<span>${newText}</span>`;

      if (desc.length > 0) {
        let payload = {
          description: desc,
          title,
          isAnonymous,
          privacy,
          mentionData,
        };
        formData.append("description", desc);
        formData.append("title", title);
        formData.append("mentionData", mentionData);

        formData.append("ogp", ogp);
        formData.append("isCustomList", isListChecked);
        if (
          ogp !== null &&
          Object.keys(ogp).length > 0 &&
          ogp.urlScrape !== false
        ) {
          payload.ogp = ogp;
        }

        if (isAnonymous) {
          payload.isAnonymous = isAnonymous;
          formData.append("isAnonymous", isAnonymous);
        } else if (isAnonymous === undefined) {
          payload.isAnonymous = false;
          formData.append("isAnonymous", false);
        }

        if (
          mentionData &&
          mentionData.mentions &&
          mentionData.mentions.length > 0
        ) {
          let { mentions } = mentionData;
          isMention = true;
          sanitizedDescription.userReferences = mentions.map((e) => e.id);
          payload.users = mentions.map((e) => ({
            _id: e.id,
            organizationId: user.organizationId._id,
          }));
          formData.append("users", mentions);
          payload.mentionsText = mentionData.newValue;
          formData.append("mentionsText", mentionData.newValue);
        }

        if (item && item.groupId) {
          formData.append("privacy", "GROUP");
          payload.privacy = "GROUP";
          payload.groupStory = { _id: item.groupId };
        }

        payload.story_type = 1;
        payload.parent = item._id;

        if (matchUrl(description.value)) {
          payload.isUrl = true;
          formData.append("isUrl", true);
        }

        payload.isCustomList = isListChecked;

        payload.isMention = isMention;
        formData.append("isMention", isMention);

        payload.sanitizedDescription = sanitizedDescription;
        formData.append("sanitizedDescription", sanitizedDescription);

        // payload.template = this.props.storyType
        // formData.append('template', this.props.storyType);
        // payload.topics = topicsSelected.filter(e=>e.name!=="All")
        // formData.append('topics', payload.topics);
        payload.isMobile = isMobile;

        if (setImagesPreview && setImagesPreview.length > 0) {
          let sorted = setImagesPreview.sort(function(a, b) {
            return b.size - a.size;
          });
          Array.from(sorted).forEach((itm) => {
            delete itm.isAccepted;
            formData.append("uploads", itm.file);
          });
        }

        formData.append("isMobile", isMobile);
        formData.append("payload", JSON.stringify(payload));

        let result = { ...payload, user: { ...user } };

        this.setState((prevState) => ({
          showResponses: [result, ...prevState.showResponses],
          showReplies: false,
          isCommentsOpen: false,
        }));

        axios.post(url.createStoryResponse, formData).then(({ data }) => {
          that.props.storyMetricsChange({ type: "replies", value: 1 });

          // console.log('new response ---',data.data)

          let result = { ...data.data, user: { ...user } };
          let prev_comments =
            this.state.showResponses.length > 0
              ? this.state.showResponses.slice(1)
              : [];
          let story_comments = [result, ...prev_comments];

          that.setState((prevState) => ({
            showResponses: story_comments,
            description: "",
            isDescription: null,
            isBadWords: "",
            isSubmit: false,
            disableSubmit: false,
            title: "",
            privacy: true,
            disableSubmit: false,
            isAnonymous: false,
            mentionsSelected: [],
            mentionsFound: [],
            setImagesPreview: [],
            mentionWord: "",
            showReplies: false,
            isCommentsOpen: false,
            responseCounter: prevState.responseCounter + 1,
          }));

          // console.log("show responses on story")
          // this.showStoryComments(item._id)
        });

        that.setState({
          showCreateStoryModal: false,
          description: "",
          title: "",
          privacy: true,
        });
      } else {
        that.setState({ showCreateStoryModal: true });
      }
    } else {
      this.setState({ disableCreate: false, isSubmit: false });

      if (description && description.value && description.value.length == 0) {
        this.setState({ isDescription: "No description" });
      }

      if (cleanDesc && cleanDesc.length > 0) {
        this.setState({ isBadWords: cleanDesc });
      }
    }
  };

  handleChangeStoryDescription = (event) => {
    let descriptionContext = event.target.value;
    // let descriptionContext = event.editor.getData();
    // console.log(descriptionContext)
    // console.log(this.state.description.value)
    let word, value;

    let { mentionsFound, mentionWord } = this.state;
    if (descriptionContext === "") {
      word = [];
      value = "";
    } else {
      word = mentionsFound;
      value = mentionWord;
    }
    let valCheck = event.target.value
      .replace(/<\/?![^>]+(>|$)/g, "")
      .replace(/[\. ,:-]+/g, "")
      .replace(/^\n|\n$/g, "");

    this.setState({
      description: { value: descriptionContext },
      mentionWord: value,
      mentionsFound: word,
      disableSubmit: valCheck.length === 0,
    });
  };

  selectUserMention = (val) => {
    // console.log(val)
    // console.log(val.toString(), typeof val, JSON.parse(val))
    let obj = JSON.parse(val);
    // console.log(obj)
    this.setState((prevState) => ({
      mentionsFound: [],
      mentionWord: "",
      // description: {value: text},
      mentionsSelected: [...prevState.mentionsSelected, obj],
    }));
  };

  fetchUsers = (query, callback) => {
    let users;
    // console.log(query)
    if (!query) return;
    axios
      .get(url.findUser(query))
      .then((resp, idx) =>
        resp.data.data.map((user) => ({
          display: "@" + user.firstName + " " + user.lastName,
          id: `{ "_id": "${user._id}", "email": "${
            user.email
          }", "name": "${user.firstName + " " + user.lastName}"}`,
          // {_id:user._id, email: user.email, idx},
          // name: user.firstName + " " + user.lastName,
          // _id: user._id,
          // email: user.email,
        }))
      )
      .then(callback);
  };

  handlePermissionChange = (changeEvent) => {
    this.setState({
      isAnonymous: changeEvent.target.checked,
    });
  };

  archiveStory = (item, actionType) => {
    actionType === "Archive"
      ? this.deleteStory(item._id)
      : this.deArchiveStory(item._id);
    this.toggleDropdown(item._id);
  };

  deleteStory = (id) => {
    axios.put(url.archiveStory(id)).then((data) => {
      //   this.props.getStoryFeeds();
      this.setState({
        dropdownOpen: false,
        showArchived: true,
      });
    });
  };

  deArchiveStory = (id) => {
    let { item } = this.state;
    axios.put(url.deArchiveStory(id)).then((data) => {
      //   this.props.getStoryFeeds();
      const result = data;
      this.setState({
        item: { ...item, isDeleted: false, isArchived: false },
        dropdownOpen: false,
      });
    });
  };

  changeStoryCounter = (val) => {
    this.setState((prevState) => ({
      responseCounter: prevState.responseCounter + val,
    }));
  };

  removeStoryConfirmation = () => {
    let { storyIdRemove, item } = this.state;
    let { user } = this.props;
    // console.log("storyu -- ", storyIdRemove)
    this.setState({ showRemoveFeedConfirmationModal: false });
    axios.put(url.removeStoryFeeds(storyIdRemove)).then((resp) => {
      this.setState({
        dropdownOpen: false,
      });

      if (
        resp.data.data.parentStory &&
        resp.data.data.parentStory.item &&
        resp.data.data.type === "storyResponse"
      ) {
        if (item.userId === user.profile._id)
          this.props.storyMetricsChange({ type: "replies", value: -1 });

        this.changeStoryCounter(-1);

        this.showStoryComments(resp.data.data.parentStory.item);
      } else {
        if (item.userId === user.profile._id)
          this.props.storyMetricsChange({ type: "story", value: -1 });

        // this.props.getStoryFeeds(this.props.user);
      }

      // this.props.history.push(`/home/stories`)
    });
  };

  showStoryRemoveConfirmation = (storyId, storyType) => {
    // console.log("storyu -- ", storyId)
    // this.props.showStoryRemoveConfirmation(storyId)
    // console.log(this.props)
    // console.log(storyId)
    this.setState({
      showRemoveFeedConfirmationModal: !this.state
        .showRemoveFeedConfirmationModal,
      storyIdRemove: storyId,
      storyType: storyType,
    });
  };

  closeStoryRemoveConfirmation = (storyId) => {
    this.setState({
      showRemoveFeedConfirmationModal: false,
      storyIdRemove: "",
    });
  };

  createMarkup = (input) => {
    // console.log(input)
    return { __html: `<div>${input}</div>` };
  };

  createResponse = () => {
    this.setState((prevState) => ({
      showReplies: !prevState.showReplies,
      showReactions: false,
    }));
  };

  showStoryComments = (item) => {
    // console.log(item)
    // console.log("item----")
    let itm = item;
    this.setState({ showReactions: false });
    if (this.state.isCommentsOpen !== false) {
      axios.get(url.getStoryComments(itm)).then(({ data }) => {
        // console.log(data)
        let arr = data.data.storyList;
        this.setState((prevState) => ({
          showResponses: arr,
          isCommentsOpen: false,
          responseCounter: arr.length,
        }));
      });
    } else {
      this.setState((prevState) => ({
        isCommentsOpen: true,
      }));
    }
  };

  navigateLink = (e) => {
    let className = e.target.className;
    if (isMobile && className == "userMentionWord") {
      e.preventDefault();
    }
  };

  addReaction = (val, isAnonymous) => {
    let { user } = this.props;
    let { reactionList, item, userReactions, reactionCounter } = this.state;
    // console.log(reactionCounter)
    // console.log(val)
    // console.log(user)
    let payload = {
      userId: user.profile._id,
      reaction: val,
      _id: val,
      user: user.profile,
      createdOn: Date.now,
      storyId: item._id,
      storyOwner: item.userId,
      orgId: user.profile.organizationId._id,
      isAnonymous,
    };

    // if(this.state.reactionList.indexOf(payload.userId)>-1)
    let rList = reactionList;
    let uR = userReactions;
    let isReactionListModified = false;
    let isUserListModified = false;

    rList.map((e) => {
      if (e.userId === payload.userId) {
        e.reaction = payload.reaction;
        isReactionListModified = true;
      }
    });

    uR.map((e) => {
      if (e.user._id === payload.userId) {
        e.reaction = val;
        e._id = val;
        e.user.firstName = payload.user.firstName ? payload.user.firstName : "";
        e.user.lastName = payload.user.lastName ? payload.user.lastName : "";
        e.user.profilePic = profilePicValidityCheck(payload.user.profilePic)
          ? payload.user.profilePic
          : "";
        isUserListModified = true;
      }
    });

    if (isReactionListModified) {
      this.setState((prevState) => ({
        reactionList: [...rList],
      }));
    } else {
      if (reactionList.length < 3) {
        this.setState((prevState) => ({
          reactionList: [
            { reaction: val, userId: user.profile._id },
            ...prevState.reactionList,
          ],
          reactionCounter: prevState.reactionCounter + 1,
        }));
      } else {
        this.setState((prevState) => ({
          reactionCounter: prevState.reactionCounter + 1,
        }));
      }
    }

    if (isUserListModified) {
      this.setState((prevState) => ({
        userReactions: [...uR],
      }));
    } else {
      this.setState((prevState) => ({
        userReactions: [payload, ...prevState.userReactions],
      }));
    }

    axios.post(url.addReaction(item._id), payload).then(({ data }) => {
      this.props.storyMetricsChange({ type: "reactions", value: 1 });
      // console.log(data)
    });
  };

  pickImage = (val) => {
    let selected = storyReactions.filter((x) => x._id === val)[0];
    return selected && selected.image;
  };

  showReactionList = () => {
    const { item } = this.state;
    axios.get(url.userReactions(item._id)).then(({ data }) => {
      // console.log(data.data, this.state.userReactions)
      let value = data.data;
      if (value.storyList && value.storyList.length > 0) {
        this.setState((prevState) => ({
          showUserReactions: true,
          userReactions: [...value.storyList],
        }));
      } else if (this.state.userReactions.length > 0) {
        this.setState((prevState) => ({
          showUserReactions: true,
          userReactions: [...prevState.userReactions],
        }));
      }
    });
  };

  removeReactionHover = () => {
    // console.log('counter---', this.state.reactionCounter)
    this.setState((prevState) => ({
      showReactions: false,
    }));
  };

  closeReactionModal = () => {
    this.setState({ showUserReactions: false });
  };

  removeReaction = () => {
    // console.log("remove reaction")
    let userId = this.props.user.profile._id;
    let storyId = this.state.item._id;
    let userRlist = this.state.userReacted;
    let reactionList = this.state.reactionList;
    // console.log(userRlist, this.props.user.profile, reactionList)

    if (userRlist.length > 0) {
      let ulist = userRlist.filter(
        (e) => e.userId != this.props.user.profile._id
      );
      // console.log(ulist)
      this.setState({ userReacted: [...ulist] });
    }

    if (reactionList.length > 0) {
      let rlist = reactionList.filter(
        (e) => e.userId != this.props.user.profile._id
      );
      // console.log(rlist)
      this.setState((prevState) => ({
        reactionList: [...rlist],
        reactionCounter: prevState.reactionCounter - 1,
      }));
    }

    axios.delete(url.deleteReaction(storyId, userId)).then(({ data }) => {
      // console.log(data)
      this.props.storyMetricsChange({ type: "reactions", value: -1 });
    });
  };

  returnSiteName = () => {
    const { item } = this.props;
    if (item) {
      if (item.ogp && item.ogp !== "undefined" && item.ogp !== null) {
        let { ogp } = item;

        let { ogUrl, twitterAppNameGooglePlay, ogSiteName } = ogp;

        let startNameURL = ogUrl.indexOf("w.") + 2;
        let endNameURL = ogUrl.indexOf(".com");
        let startEndDiff = endNameURL - startNameURL;
        let siteName = ogUrl.substr(startNameURL, startEndDiff);

        if (ogSiteName) {
          return ogSiteName;
        } else if (twitterAppNameGooglePlay) {
          return twitterAppNameGooglePlay;
        } else {
          return siteName;
        }
      }
    }
  };

  showTopicName = (topic) => {
    let { topics } = this.state;
    // console.log(filters)
    if (topic) {
      let res = topics.filter((e) => e._id === topic._id);
      if (res && res[0]) {
        return res[0].name;
      }
    }
  };

  editStory = (story) => {
    // console.log(story)
    // this.props.showCreateStory()
  };

  openCarouselModal = (type) => {
    let res = [],
      { item } = this.state;
    if (type == "i") {
      let obj = { url: item.image };
      res.push(obj);
    } else {
      res = [...item.attachments];
    }
    this.setState((prevState) => ({
      showCarousel: !prevState.showCarousel,
      carouselData: res,
    }));
  };

  goToProfile = (profilePicSrc) => {
    let profileURL = dynamic_urls(
      this.state.item.userId,
      this.state.item.organizationId
    ).my_profile;
    this.props.history.push(profileURL);
  };

  closeCarousel = () => {
    this.setState({ showCarousel: false });
  };

  canSubmit = (val) => {
    this.setState({ ...val });
    // this.setState({disableSubmit:val})
  };

  fileSelectedHandler = (e) => {
    let { setImagesPreview } = this.state;
    this.setState({ imageError: null });
    if (e.target.files) {
      let arr = [];
      let fileArr = Array.from(e.target.files).map((file, idx) => {
        let obj = {
          name: file.name,
          type: file.type,
          size: file.size,
          file,
          preview: URL.createObjectURL(file),
          isAccepted: checkUploadType(file.type),
        };
        return uploadPreview(obj);
      });

      let acceptedFiles = fileArr.filter((e) => e.isAccepted == true);

      let rejectedFiles = fileArr.filter((e) => e.isAccepted == false);
      let allUploads = acceptedFiles.concat(rejectedFiles);

      let acceptedLength = setImagesPreview.length + acceptedFiles.length;
      if (acceptedLength < 6) {
        this.setState((prevState) => ({
          setImagesPreview: prevState.setImagesPreview.concat(acceptedFiles),
          rejectedFiles: prevState.rejectedFiles.concat(rejectedFiles),
        }));
        Array.from(e.target.files).map((file) => URL.revokeObjectURL(file));
      } else {
        this.setState({
          imageError: 2,
        });
      }
    }
  };

  renderUploadPreview = (source) => {
    let { rejectedFiles } = this.state;

    return source.map((photo, idx) => {
      let { preview, size } = photo;
      let mb = 1024 * 1024;
      let file_size =
        size >= mb
          ? `${(size / mb).toFixed(2)}mb`
          : `${(size / 1024).toFixed(2)}kb`;
      return (
        <span
          key={idx}
          className={
            photo.isAccepted == false
              ? "storyUploadPreviewImg rejectedFilesContainer commentRemoveImageContainer"
              : "storyUploadPreviewImg"
          }
        >
          {photo.type && photo.type.indexOf("video") > -1 ? (
            <ReactPlayer
              url={preview}
              // controls={true}
              width="125px"
              height="69px"
            />
          ) : (
            <img src={preview} className="fileUploadSize" />
          )}
          <span
            key={preview + idx}
            onClick={() => this.removeImage(photo)}
            className="commentRemoveImage"
          >
            <span className="flaticon-trash" />
          </span>
        </span>
      );
    });
  };

  removeImage = (photo) => {
    let { setImagesPreview } = this.state;
    let { preview } = photo;
    setImagesPreview.map((el) => URL.revokeObjectURL(el.file));
    let result = setImagesPreview.filter((e) => e.preview != preview);
    URL.revokeObjectURL(preview);
    URL.revokeObjectURL(photo.file);
    this.setState({ setImagesPreview: result });
  };

  renderCondition = () => {
    let currentUser = this.props.user.profile;
    let { item } = this.state;
    const { orgAdmin } = this.props.user.profile;

    if (
      orgAdmin ||
      currentUser._id === item.userId ||
      (item &&
        item.groupId &&
        currentUser.groupStory &&
        currentUser.groupStory.groupId &&
        currentUser.groupStory.groupId.toString() == item.groupId.toString()) ||
      (item &&
        item.groupId &&
        currentUser.groups &&
        currentUser.groups.length > 0 &&
        currentUser.groups.filter(
          (e) => e.o_id.toString() == item.groupId.toString()
        ).length > 0)
    ) {
      return true;
    }
  };
  createMarkDown = (string) => {
    console.log("str ---- ", string);
    let m_down = marked.parse(string, {
      breaks: true,
    });

    console.log("m_down --- ", m_down);
    return m_down;
  };

  renderAsHtml = (text) => {
    return parse(this.createMarkDown(text));
  };

  goToGroup = (item) => {
    let { groupId, organizationId } = item;
    this.props.history.push(`/home/groups/${organizationId}/view/${groupId}`);
  };

  getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  handleCommentUpdate = (story) => {
    const { showResponses } = this.state;
    let storiesArray = [...showResponses];
    const storyIndex = storiesArray.findIndex((x) => x._id === story._id);

    if (storyIndex >= 0) {
      if (story.isFlagged && story.isFlagged.status === true) {
        storiesArray.splice(storyIndex, 1);
        this.setState({ showResponses: [...storiesArray] });
      } else {
        storiesArray[storyIndex] = { ...storiesArray[storyIndex], ...story };
        console.log(storiesArray);
        this.setState({ showResponses: [...storiesArray] });
      }
    }
  };
  showAllSharedUsers = (users) => {
    this.setState({ sharedUsersOpen: true, sharedUsers: users });
  };

  showOthersShared = (item) => {
    const sharedWith = item.sharedWith.filter(
      (x) => x.userId !== this.props.user.profile._id
    );
    let string = "";
    for (let index = 0; index < sharedWith.length; index++) {
      const ele = sharedWith[index];
      if (index === 0) {
        string += `${ele.firstName} ${ele.lastName}`;
      } else if (index === 1) {
        string += `, ${ele.firstName} ${ele.lastName}`;
      } else {
        string = (
          <span>
            {string} and{" "}
            <b
              className="cursor-pointer storySharedText-shared-list"
              onClick={() => this.showAllSharedUsers(item.sharedWith)}
            >
              others
            </b>
          </span>
        );

        break;
      }
    }
    console.log(string);
    return string;
  };

  onStoryEditSuccess = (editedStory, noflag = true) => {
    // Update here on Story success edits
    if (noflag) {
      this.setState({
        isFlagged: { ...editedStory.isFlagged },
        item: { ...this.state.item, isFlagged: { ...editedStory.isFlagged } },
      });
    } else {
      this.setState({
        item: { ...this.state.item, ...editedStory },
      });
    }

    if (this.props.editParticularStoryobj) {
      this.props.editParticularStoryobj(editedStory);
    }
  };

  reportedModalId = (val) => {
    this.setState({ reportedModalId: val });
  };

  renderStories = () => {
    const isAdmin =
      this.props.user.profile.role === "Admin" ||
      this.props.user.profile.role === "SuperAdmin";
    const list = orderBy(this.state.stories, "createdOn", "desc");
    const { orgAdmin } = this.props.user.profile;
    // const { item, actionType, avatar } = this.state;
    let { isArchived } = this.props;

    let {
      isCommentsOpen,
      item,
      actionType,
      avatar,
      description,
      isVideo,
      disableCreate,
      setImagesPreview,
      isDescription,
      isFlagged,
      isSubmit,
      showUserReactions,
      isAnonymous,
      disableSubmit,
      reactionList,
      showResponses,
      responseCounter,
    } = this.state;

   

    console.log("hhhhhhhhhh", item.sharedWith);

    const createStoryModalStyle = classnames(
      "addStoryComment btn btn-primary",
      {
        disabled: disableSubmit,
      }
    );
    // console.log(item, this.props)
    // console.log('otem---', item)

    let currentUser = this.props.user.profile;

    if (item && item.description) {
      let itemTemplate = storyTemplates.filter((val) => {
        if (item.template && item.template._id) {
          return item.template._id === val._id ? val : null;
        } else {
          return null;
        }
      });

      actionType =
        item.isDeleted === true || item.isArchived === true
          ? "Restore"
          : "Archive";

      const storyIsShared =
        item.sharedWith && item.sharedWith.length > 0
          ? item.sharedWith.length
          : 0;

      let isStorySharedWithOrgAdmin = false;
      if (orgAdmin) {
        const orgAdminShared =
          item &&
          item.sharedWith &&
          item.sharedWith.find((x) => x.userId === this.props.user.profile._id);
        if (orgAdminShared) {
          isStorySharedWithOrgAdmin = true;
        }
      }

      const isFlaggedStory = item.isFlagged && item.isFlagged;

      const renderFlagged = orgAdmin
        ? false
        : item.isFlagged
        ? item.isFlagged.status
        : false;

      return (
        <div>
          <div className={`${isFlaggedStory ? "single-flagged-stories" : ""}`}>
            <If condition={isMobile}>
              <span
                className={`singleStory ${
                  isFlaggedStory ? "single-flagged-stories" : ""
                }`}
                onClick={() => this.props.history.push("/home/stories")}
              >
                {staticTitles.storyItemsU}
              </span>{" "}
              <span className="singleStoryName">
                {" "}
                {item.isAnonymous
                  ? "Anonymous user"
                  : this.props.user.profile._id === item.userId
                  ? "me"
                  : item.fullname}{" "}
              </span>
            </If>
            <div
              className={`${!isMobile && ""} ${item.isTrending &&
                "trendingContent"} story-list list-group-item`}
              key={item._id}
            >
              <div className="avatar">
                {item.isAnonymous || (item.user && item.user.status=="INACTIVE") ? (
                  <img
                    src={avatarIcon}
                    className="avatar-pic noPointer"
                    alt=""
                  />
                ) : profilePicValidityCheck(item.profilePic) ? (
                  <img
                    src={item.profilePic}
                    className="avatar-pic"
                    alt=""
                    onClick={this.goToProfile}
                  />
                ) : (
                  <span
                    className="spotlightUserInitials"
                    onClick={this.goToProfile}
                    data-letters={this.getInitials(item.user)}
                  />
                )}

                <span className="storyOwner">
                  <span className="storyUsername">
                    {item.isAnonymous
                      ? "Anonymous user" : item.user && item.user.status=="INACTIVE" ? "Deactivated user"
                      : this.props.user.profile._id === item.userId
                      ? "me"
                      : item.fullname}{" "}
                  </span>
                  <span className="user_gender_pronoun_story ml-1">
                    {item.isAnonymous ? (
                      ""
                    ) : (
                      <span>{renderGenderPronoun(item.user)}</span>
                    )}
                  </span>

                  {storyIsShared > 0 && !orgAdmin ? (
                    <span className="storySharedText">
                      {storyIsShared == 1 ? (
                        "shared this post with You"
                      ) : (
                        <span>
                          shared this post with {this.showOthersShared(item)}
                        </span>
                      )}
                    </span>
                  ) : storyIsShared > 0 &&
                    orgAdmin &&
                    isStorySharedWithOrgAdmin ? (
                    <span className="storySharedText">
                      {storyIsShared == 1 ? (
                        `shared this post with You`
                      ) : (
                        <span>
                          shared this post with {this.showOthersShared(item)}
                        </span>
                      )}
                    </span>
                  ) : storyIsShared > 0 &&
                    orgAdmin &&
                    !isStorySharedWithOrgAdmin ? (
                    <span className="storySharedText">
                      {storyIsShared == 1 ? (
                        <span>
                          shared this post with {this.showOthersShared(item)}
                        </span>
                      ) : (
                        <span>
                          shared this post with {this.showOthersShared(item)}
                        </span>
                      )}
                    </span>
                  ) : (
                    ""
                  )}

                  <br />
                  <span className="storyDate">
                    {moment(item.createdOn).format("MMM D, YYYY")}
                    {item.isDani && (
                      <img src={DaniIcon} className="story-isdani-logo" />
                    )}
                  </span>
                  {actionType == "Restore" ? (
                    <span className="archived-tag">Archived</span>
                  ) : null}
                </span>
              </div>

              {renderFlagged && (
                <div className="story-flaggedby-div story-flagged-text">
                  {" "}
                  This story has been flagged and is under review{" "}
                  <BiInfoCircle
                    className="ml-2"
                    data-tip="Under Review:  While under review, only your admin and you will have access to it. "
                  />
                </div>
              )}

              {itemTemplate &&
              itemTemplate !== [] &&
              itemTemplate.length > 0 ? (
                <div
                  className="storyTopics itemTemplate"
                  style={{
                    backgroundColor: itemTemplate[0].color,
                    color: "black",
                    border: itemTemplate[0].border,
                  }}
                >
                  {/* <img src={e.image} className="templateImage"/> */}
                  {itemTemplate[0].name}
                </div>
              ) : null}

              {item.topics && item.topics.length > 0
                ? item.topics.map((topic, idx) => {
                    return (
                      <div className="storyTopics" key={idx}>
                        {this.showTopicName(topic)}
                      </div>
                    );
                  })
                : null}

              <div
                className="story-list col-xs-12"
                onClick={(e) => this.navigateLink(e)}
              >
                <div
                  className={`${isMobile && "mb-0"} mainStoryContent`}
                  // dangerouslySetInnerHTML={this.createMarkup(
                  //   item.description.replace(/\n/g, "<br />")
                  // )}
                  // dangerouslySetInnerHTML={this.createMarkup(item.description)}
                >
                  {this.renderAsHtml(item.description)}
                </div>

                {item &&
                item.ogp &&
                item.ogp !== null &&
                item.ogp !== "undefined" &&
                item.ogp.hasOwnProperty("urlScrape") &&
                item.ogp.urlScrape == true &&
                isVideo != true &&
                item.attachments &&
                item.attachments.length == 0 ? (
                  <div className="ogContainer">
                    <a className="ogHref" href={item.ogp.ogUrl} target="_blank">
                      {item.ogp.ogImage && item.ogp.ogImage.url ? (
                        <span className="story_image_full_container">
                          <div
                            className="event_details_bg_image_blur"
                            style={{
                              backgroundImage: `url(${item.ogp.ogImage.url})`,
                              // backgroundImage: item.ogp.ogImage ? `url(${item.ogp.ogImage.url})`:"",
                            }}
                          />

                          <img src={item.ogp.ogImage.url} className="ogImage" />
                        </span>
                      ) : (
                        ""
                      )}

                      <div className="ogContent">
                        <span className="ogSite">
                          {this.returnSiteName()}
                          {/* <a href= {item.ogp.ogUrl} target="_blank">
                        {this.returnSiteName()}
                    </a> */}
                        </span>
                        <span className="ogTitle">{item.ogp.ogTitle}</span>
                      </div>
                    </a>
                  </div>
                ) : null}

                {isVideo ? (
                  <div className="imgFixContainer">
                    <ReactPlayer
                      width="100%"
                      playing={true}
                      muted={true}
                      controls={true}
                      volume={0}
                      url={item.ogp.ogUrl}
                    />
                  </div>
                ) : null}

                {item.attachments && item.attachments.length > 0 ? (
                  <div onClick={() => this.openCarouselModal()}>
                    <StoriesPhotoGrid attachments={item.attachments} />
                  </div>
                ) : null}

                {item.image &&
                item.attachments &&
                item.attachments.length == 0 ? (
                  <div className="imgFixContainer">
                    <img
                      onClick={() => this.openCarouselModal("i")}
                      src={item.image}
                      className="imgFix imgCursor"
                    />
                  </div>
                ) : null}
              </div>

              {!renderFlagged && (
                <div>
                  {isArchived != true ? (
                    <div className="singleStory reactionsHover row">
                      <div className="col-3 comment-action-item reactionsContainer">
                        <Reactions
                          removeReaction={this.removeReaction}
                          saveReaction={this.addReaction}
                          hideReactions={this.state.showReactions}
                          userReacted={this.state.userReacted}
                        />
                      </div>
                      <div className="col-4 comment-action-item replyContainer">
                        <div
                          className="replyStory"
                          onClick={this.createResponse}
                        >
                          <IoChatboxOutline size={"24px"} color="gray" />
                          {!isMobile ? "Comment" : "  Leave a comment"}
                        </div>
                      </div>

                      <ShareStory
                        item={item}
                        user={this.props.user}
                        entityType="STORY"
                        col
                        display="POPPER"
                      />
                    </div>
                  ) : null}
                </div>
              )}

              <ReportStoryModal
                story={item}
                handleFlagSuccess={this.onStoryEditSuccess}
                renderFlagged={renderFlagged}
                handleUnflagSuccess={this.onStoryEditSuccess}
                orgAdmin={orgAdmin}
                isReportedItem={this.reportedModalId}
              />

              <If condition={this.renderCondition()}>
                {!renderFlagged && (
                  <Dropdown
                    isOpen={
                      this.state.dropdownOpen === item._id ||
                      this.state.reportedModalId == item._id
                        ? true
                        : false
                    }
                    toggle={() => this.toggleDropdown(item._id)}
                    className="wwDropdown"
                  >
                    <DropdownToggle
                      tag="span"
                      className="chart-item-menu"
                      onClick={() => this.toggleDropdown(item._id)}
                      data-toggle="dropdown"
                      aria-expanded={
                        this.state.dropdownOpen === item._id ? true : false
                      }
                    >
                      <BiDotsHorizontalRounded size={"26px"} color="gray" />
                    </DropdownToggle>

                    <If condition={this.renderCondition()}>
                      <DropdownMenu
                        right
                        className="chart-dropdown"
                        style={{ padding: "0" }}
                      >
                        <div>
                          {/* For View Group if post is in gorup  */}
                          <If
                            condition={
                              !isArchived &&
                              this.props.user.profile._id === item.userId
                            }
                          >
                            <div
                              className="chart-list-dropdown-options"
                              style={{ display: "flex" }}
                              onClick={() => this.toggleEditPopup()}
                            >
                              <i className="chart-item-menu flaticon-edit"></i>
                              <span className="chart-list-dropdown-options-text">
                                Edit Story
                              </span>
                            </div>
                          </If>

                          {item && item.groupId ? (
                            <div
                              className="chart-list-dropdown-options"
                              style={{ display: "flex" }}
                              onClick={() => this.goToGroup(item, actionType)}
                            >
                              {/* <i className="chart-item-menu flaticon-update"></i> */}
                              {/* <img src={groupIcon} className="single_story_dd_grpIcon"/> */}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className=""
                                viewBox="0 0 16 16"
                              >
                                <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275zM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z" />
                              </svg>
                              <span className="chart-list-dropdown-options-text">
                                View in Group
                              </span>
                            </div>
                          ) : null}

                          {isArchived === true ? (
                            <If
                              condition={
                                isAdmin ||
                                this.props.user.profile._id === item.userId
                              }
                            >
                              <div>
                                <If
                                  condition={
                                    this.props.user.profile._id === item.userId
                                  }
                                >
                                  <div
                                    className="chart-list-dropdown-options"
                                    style={{ display: "flex" }}
                                    onClick={() =>
                                      this.deArchiveStory(item, actionType)
                                    }
                                  >
                                    <i className="chart-item-menu flaticon-update"></i>
                                    <span className="chart-list-dropdown-options-text">
                                      {actionType}
                                    </span>
                                  </div>
                                </If>
                              </div>
                            </If>
                          ) : (
                            <div>
                              <If
                                condition={
                                  orgAdmin ||
                                  this.props.user.profile._id === item.userId
                                }
                              >
                                <div
                                  className="chart-list-dropdown-options"
                                  style={{ display: "flex" }}
                                  onClick={() =>
                                    this.showStoryRemoveConfirmation(item._id)
                                  }
                                >
                                  <i className="chart-item-menu flaticon-minus"></i>
                                  <span className="chart-list-dropdown-options-text">
                                    Remove from Feed
                                  </span>
                                </div>
                              </If>
                              <If
                                condition={
                                  this.props.user.profile._id === item.userId
                                }
                              >
                                <div
                                  className="chart-list-dropdown-options"
                                  style={{ display: "flex" }}
                                  onClick={() =>
                                    this.archiveStory(item, actionType)
                                  }
                                >
                                  <If condition={actionType === "Restore"}>
                                    <i className="chart-item-menu flaticon-update"></i>
                                  </If>
                                  <If condition={actionType === "Archive"}>
                                    <i className="chart-item-menu flaticon-trash"></i>
                                  </If>
                                  <span className="chart-list-dropdown-options-text">
                                    {actionType}
                                  </span>
                                </div>
                              </If>
                              {this.props.user.profile._id !== item.userId ||
                              renderFlagged ? (
                                <div className="chart-list-dropdown-options">
                                  <ReportStoryModal
                                    isTextOnly={true}
                                    story={item}
                                    isReportedItem={this.reportedModalId}
                                    handleFlagSuccess={this.onStoryEditSuccess}
                                    renderFlagged={this.props.renderFlagged}
                                    handleUnflagSuccess={
                                      this.onStoryEditSuccess
                                    }
                                    orgAdmin={orgAdmin}
                                  />
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          )}
                        </div>
                      </DropdownMenu>
                    </If>
                  </Dropdown>
                )}
              </If>

              {!renderFlagged && (
                <div className="storyOptionsContainer">
                  {this.state.reactionList &&
                  this.state.reactionList.length > 0 ? (
                    <div
                      onClick={this.showReactionList}
                      className="reactionsContainer"
                    >
                      {this.state.reactionList.map((e, idx) => {
                        return (
                          <img
                            className="reactionItems"
                            src={this.pickImage(e.reaction)}
                            key={idx}
                          />
                        );
                      })}
                      <span className="reactionCounter">
                        {this.state.reactionCounter}
                      </span>
                    </div>
                  ) : (
                    <span className="noReactions">No Reactions</span>
                  )}

                  {responseCounter > 0 ? (
                    <span
                      className="viewComments"
                      // onClick={() => this.seeStory(item)}
                    >
                      {responseCounter === 1
                        ? `1 Comment`
                        : `${responseCounter} Comments`}
                    </span>
                  ) : (
                    <span className="noReplies">No Comments</span>
                  )}
                </div>
              )}

              {this.state.showCarousel ? (
                <StoriesPhotoCarousel
                  closeCarousel={this.closeCarousel}
                  //  attachments={item.attachments}
                  attachments={this.state.carouselData.sort(function(a, b) {
                    return b.size - a.size;
                  })}
                  showCarousel={this.state.showCarousel}
                />
              ) : null}

              {this.state.showUserReactions ? (
                <Modal
                  isOpen={this.state.showUserReactions}
                  className="archive-modal show-user-reactions"
                >
                  <ModalBody>
                    <div className="modal-title reactionListTitle">
                      {this.state.userReactions.length} Reactions
                    </div>
                    <div className="modal-content-wrapper word-break reactionModal">
                      {this.state.userReactions &&
                      this.state.userReactions.length > 0
                        ? this.state.userReactions.map((e, idx) => {
                            return (
                              <div className="userReactionContainer" key={idx}>
                                <div>
                                {e.isAnonymous ? (

                                  <img
                                    //  onClick={this.goToProfile}
                                    className="userReactionPic"
                                    src={avatarIcon}
                                  />
                                ) : (
                                  <img
                                    className="userReactionPic"
                                    src={
                                      profilePicValidityCheck(e.user.profilePic)
                                        ? e.user.profilePic
                                        : UserIcon4
                                    }
                                  />
                                )}

                                
                                  <span className="userReactionName">
                                  {e.isAnonymous ? e.userId == this.props.user.profile._id ? "You (anonymous)" : "Anonymous User"  : (
                                  <span >
                                    {e.user.firstName} {e.user.lastName}
                                  </span>
                                )}

                                  </span>
                                </div>

                                <img
                                  className="reactionModalImage"
                                  src={this.pickImage(e._id)}
                                />
                              </div>
                            );
                          })
                        : null}
                    </div>

                    <Row
                      className={`mt30 ${isMobile && "reaction-close"}`}
                      style={{ marginLeft: "9px" }}
                    >
                      <Col sm={{ size: 4 }} md={{ size: 4 }}>
                        <Button
                          className="archive-button"
                          onClick={this.closeReactionModal}
                        >
                          Close
                        </Button>{" "}
                      </Col>
                    </Row>
                  </ModalBody>
                </Modal>
              ) : null}

              {this.state.showReplies ? (
                // ${isSubmit?'disabled':''}
                <div className={`mentionsReplyInput `}>
                  {/* {isSubmit?<img src={Spinner} className="reply-spinner-pos"/>:null} */}
                  <span
                    className="post-comment-me"
                    style={{ position: "absolute" }}
                  >
                    {item.isAnonymous ? (
                      <img
                        src={avatarIcon}
                        className="avatar-pic noPointer"
                        alt=""
                      />
                    ) : profilePicValidityCheck(item.profilePic) ? (
                      <img
                        src={item.profilePic}
                        className="avatar-pic"
                        alt=""
                        onClick={this.goToProfile}
                      />
                    ) : (
                      <span
                        className="spotlightUserInitials"
                        onClick={this.goToProfile}
                        data-letters={this.getInitials(item.user)}
                      />
                    )}
                  </span>
                  <StoryMentionsText
                    isModule={item && item.groupId ? "GROUP" : null}
                    storyLimit={2000}
                    // groupObj = {this.props.group}
                    canSubmit={this.canSubmit}
                    storyType={"Write a comment..."}
                  />

                  <Button
                    // className={createStoryModalStyle}
                    color="primary"
                    className={`addStoryComment btn btn-primary ${
                      disableSubmit ? "disabled" : ""
                    }`}
                    onClick={this.handleCreateStoryResponse}
                  >
                    <span className="profile-modal-save-btn-txt"> Post</span>
                  </Button>

                  <span className="mentionsStoryCamera">
                    <label
                      htmlFor="profile-pic-file-input"
                      style={{ marginBottom: "0px" }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className=""
                        viewBox="0 0 16 16"
                      >
                        <path d="M10.5 8.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"></path>
                        <path d="M2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2zm.5 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm9 2.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0z"></path>
                      </svg>
                    </label>
                    <input
                      id="profile-pic-file-input"
                      onClick={!disableCreate ? this.handleClick : null}
                      onChange={this.fileSelectedHandler}
                      type="file"
                      multiple
                    />
                  </span>

                  <div>
                    {setImagesPreview && setImagesPreview.length > 0 ? (
                      <div className="taskUploadPreviewContainer mb0 commentImageSectionContainer">
                        <div className="taskUploadPreviewContainerOverflow commentImageSectionRow">
                          {this.renderUploadPreview(setImagesPreview)}
                        </div>
                      </div>
                    ) : null}
                  </div>

                  <div
                    className="anonymousStoryResponse"
                    hidden={!this.state.isAnonymousVisible}
                  >
                    <span className="ml10">
                      <Toggle
                        checked={isAnonymous}
                        icons={false}
                        onChange={this.handlePermissionChange}
                      />
                    </span>
                    <span className="permission-value ml10">Anonymous</span>
                  </div>
                  {isDescription === "" ? "Please include a description" : null}
                  {this.state.isBadWords.length > 0 ? (
                    <span className="badwords">
                      {" "}
                      There appears to be a profane or insensitive word in your
                      post: <strong>{this.state.isBadWords.join(", ")}</strong>.
                      Please remove them and try posting your reply again.
                      {/* Please contact us at <a href="mailto:support@ouroffice.io "> support@ouroffice.io </a> if you continue to have a problem. */}
                    </span>
                  ) : null}
                </div>
              ) : null}

              {showResponses && showResponses.length > 0 ? (
                <div
                  className={
                    isCommentsOpen === false ? "storyItemsContainer" : ""
                  }
                >
                  {showResponses.map((e) => {
                    if (e.isDeleted !== true) {
                      const avatar = e.isAnonymous
                        ? avatarIcon
                        : profilePicValidityCheck(e.profilePic)
                        ? e.profilePic
                        : avatarIcon;
                      return (
                        <div key={e._id}>
                          <StoryCommentList
                            handleCommentUpdate={this.handleCommentUpdate}
                            orgAdmin={orgAdmin}
                            user={this.props.user}
                            changeStoryCounter={this.changeStoryCounter}
                            isCommentsOpen={isCommentsOpen}
                            showStoryComments={this.showStoryComments}
                            removeCommentConfirmation={
                              this.showStoryRemoveConfirmation
                            }
                            key={e._id}
                            actionType={this.props.actionType}
                            item={e}
                            avatar={avatar}
                          />
                        </div>
                      );
                    }
                  })}
                </div>
              ) : null}
            </div>

            {isMobile && <FooterBar {...this.props} />}
          </div>

          <If
            condition={orgAdmin || this.props.user.profile._id == item.userId}
          >
            {this.state.flaggedHistory.length > 0 ? (
              <span
                className="cursor-pointer ml-auto font-weight-bold text-info"
                onClick={() => {
                  this.setState({
                    flaggedHistoryOpen: !this.state.flaggedHistoryOpen,
                  });
                }}
              >
                View flagged history
              </span>
            ) : (
              ""
            )}
          </If>
        </div>
      );
    }
  };

  getStoriesCount = () => {
    const filteredStories = this.state.stories.filter(
      (story) => !story.isDeleted
    );
    return filteredStories.length;
  };

  handleCollapse = () => {
    this.setState((state) => ({ collapseCompleted: !state.collapseCompleted }));
  };

  render() {
    const {
      description,
      isAnonymous,
      disableSubmit,
      stories,
      collapseCompleted,
      categoryDefinitionPopoverOpen,
      item,
      archievedStories,
      showRemoveFeedConfirmationModal,
      isCommentsOpen,
      isVideo,
      disableCreate,
      setImagesPreview,
      showUserReactions,
      reactionList,
      showResponses,
      responseCounter,
      sharedUsers,
      sharedUsersOpen,
      flaggedHistory,
      flaggedHistoryOpen,
    } = this.state;
    const createStoryModalStyle = classnames(
      "addStoryComment btn btn-primary",
      {
        disabled: disableSubmit,
      }
    );
    console.log("2114 story------");
    // console.log('item Single --- ', item)
    if (item) {
      // console.log(this.state.reactionCounter)
      let actionType =
        item.isDeleted === true || item.isArchived === true
          ? "Restore"
          : "Archive";
      let avatar = item.isAnonymous
        ? avatarIcon
        : item.profilePic || avatarIcon;
      return (
        <div
          className={`stories  ${
            isMobile ? "" : ""
          } singleStoriesViewContainer`}
          onMouseLeave={this.removeReactionHover}
        >
          {/* <StoryItems 
            showCreateStory={()=>this.editStory(item)}
            currentRole={currentRole}
            group={this.props.group}
            removeStoryFeeds = {this.removeStoryFeeds} 
            deArchiveStory={this.deArchiveStory} 
            archiveStory={this.archiveStory} 
            filters={topics} 
            getStoryFeeds={this.getStoryFeeds} 
            showStoryRemoveConfirmation={this.showStoryRemoveConfirmation} 
            key={item._id+idx} 
            item={item} 
            actionType={actionType} 
            avatar={avatar} 
            description={description} 
        /> */}

          {this.props.user && this.props.user.profile
            ? this.renderStories()
            : null}

          <Modal
            isOpen={showRemoveFeedConfirmationModal}
            className="archive-modal remove-story-model"
          >
            <ModalBody>
              <div className="modal-title">
                Remove {this.state.storyType}
                <span
                  className="model-close"
                  onClick={this.closeStoryRemoveConfirmation}
                >
                  <i className="flaticon-close"></i>
                </span>
              </div>
              <div className="modal-content-wrapper word-break">
                You are about to Remove a {this.state.storyType}. This action is
                irreversible and will completely delete the{" "}
                {this.state.storyType}. <br />
                No one, including the author of the comment, will be able to see
                it any more.
              </div>
              <Row
                className="mt30 remove-story-buttons"
                style={{ marginLeft: "9px" }}
              >
                <Col sm={{ size: 4 }} md={{ size: 4 }}>
                  <Button
                    className="archive-button"
                    onClick={this.removeStoryConfirmation}
                  >
                    Remove {this.state.storyType}
                  </Button>{" "}
                </Col>
                <If condition={!isMobile}>
                  <Col sm={{ size: 4 }} md={{ size: 4 }}>
                    <Button
                      className="cancel-button float-right"
                      onClick={this.closeStoryRemoveConfirmation}
                    >
                      Cancel
                    </Button>
                  </Col>
                </If>
              </Row>
            </ModalBody>
          </Modal>
          {this.state.editPopupOpen && (
            <EditStory
              editPopupOpen={this.state.editPopupOpen}
              toggleEditPopup={this.toggleEditPopup}
              storyId={this.state.item._id}
              story={this.state.item}
              {...this.props}
              onEditSuccess={this.onStoryEditSuccess}
            />
          )}
          {sharedUsersOpen && (
            <SharedUsersModal
              open={sharedUsersOpen}
              users={sharedUsers}
              toggle={() => {
                this.setState({ sharedUsersOpen: false, sharedUsers: [] });
              }}
              {...this.props}
            />
          )}

          {flaggedHistoryOpen && (
            <Modal
              isOpen={flaggedHistoryOpen}
              className="dashboardModalContainer story-report-modal"
            >
              <ModalHeader
                className="dashboardHeader story-report-modal-header"
                toggle={() =>
                  this.setState({
                    flaggedHistoryOpen: !flaggedHistoryOpen,
                  })
                }
              >
                <div className="dashboardModalTitle">
                  See flagged content history
                </div>
              </ModalHeader>

              <ModalBody>
                {flaggedHistory.map((item) => (
                  <div className="flagged-story-history-card">
                    <b className="text-danger">Flagged Details : </b>

                    <Row className="mt-1">
                      {item.flaggedBy ? (
                        <Col sm={6}>
                          <b>Flagged By : </b>{" "}
                          {item.isFlaggedAnonymous
                            ? "Anonymous User"
                            : `${item.flaggedBy.firstName}  ${item.flaggedBy.lastName}`}
                        </Col>
                      ) : (
                        ""
                      )}

                      {item.flaggedDate ? (
                        <Col sm={6}>
                          <b>Flagged Date : </b>{" "}
                          {moment(item.flaggedDate).format("MMM D, YYYY")}
                        </Col>
                      ) : (
                        ""
                      )}
                    </Row>
                    <Row className="mt-2">
                      <Col sm={12}>
                        <b>Flagged Response : </b>{" "}
                        {item.flaggedRespond || "None."}
                      </Col>
                    </Row>

                    <hr />

                    <b className="text-success">Moderation Details : </b>

                    <Row className="mt-1">
                      {item.moderatedBy ? (
                        <Col sm={6}>
                          <b>Moderated By : </b> {item.moderatedBy.firstName}{" "}
                          {item.moderatedBy.lastName}
                        </Col>
                      ) : (
                        ""
                      )}
                      {item.moderationDate ? (
                        <Col sm={6}>
                          <b>Modreation Date : </b>{" "}
                          {moment(item.moderationDate).format("MMM D, YYYY")}
                        </Col>
                      ) : (
                        ""
                      )}
                    </Row>
                    <Row className="mt-2">
                      <Col sm={12}>
                        <b> Moderation Notes: </b>{" "}
                        {item.moderationNotes &&
                        item.moderationNotes.length > 0 ? (
                          <ul>
                            {item.moderationNotes.map((x) => {
                              return <li>{x.text}</li>;
                            })}
                          </ul>
                        ) : (
                          "None"
                        )}
                      </Col>
                    </Row>
                  </div>
                ))}
              </ModalBody>
            </Modal>
          )}
        </div>
      );
    } else {
      return <div>loading</div>;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    storyMetricsChange: (data) =>
      dispatch(actionCreators.storyMetricsChange(data)),
    onKpiMasterListFetched: (data) =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(SingleStory, axios)));
